import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import DreamHeader from "./DreamHeader";
import InspirationGallery from "./InspirationGallery";
import KnowledgeHub from "./KnowledgeHub";
import AICompanion from "./AICompanion";
import IdeationTools from "./IdeationTools";
import { useActivityLogger } from "@/hooks/use-activity-logger";
import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/auth/AuthContext";

const DreamPage = () => {
  const { logActivity } = useActivityLogger();
  const { currentOrganization } = useAuth();
  const [hasLoggedAccess, setHasLoggedAccess] = useState(false);
  
  useEffect(() => {
    // Only log once when the organization is available
    const logPageVisit = async () => {
      if (currentOrganization && !hasLoggedAccess) {
        try {
          await logActivity({
            action: 'view',
            resourceType: 'page',
            details: { page: 'dream' }
          });
          setHasLoggedAccess(true);
        } catch (error) {
          console.error('Error logging dream page visit:', error);
        }
      }
    };
    
    logPageVisit();
  }, [logActivity, currentOrganization, hasLoggedAccess]);

  return (
    <div className="space-y-6 p-6 pb-16">
      <DreamHeader />
      
      <Tabs defaultValue="inspiration" className="space-y-4">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="inspiration">Inspiration Gallery</TabsTrigger>
          <TabsTrigger value="knowledge">Knowledge Hub</TabsTrigger>
          <TabsTrigger value="ai">AI Companion</TabsTrigger>
          <TabsTrigger value="ideation">Ideation Tools</TabsTrigger>
        </TabsList>
        
        <TabsContent value="inspiration" className="space-y-4">
          <InspirationGallery />
        </TabsContent>
        
        <TabsContent value="knowledge" className="space-y-4">
          <KnowledgeHub />
        </TabsContent>
        
        <TabsContent value="ai" className="space-y-4">
          <AICompanion />
        </TabsContent>
        
        <TabsContent value="ideation" className="space-y-4">
          <IdeationTools />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default DreamPage;
